const Component4 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  return (
    <div
      className="grid-container w-100 h-100"
      style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "10px" }}
    >
      {items.map((item, index) => (
        <div
          key={`color-${index}`}
          onClick={() => {
            if (isOutOfStock(item)) return;
            handleSelection(selectedCategory, item.id);
          }}
          className={`
            grid-item
            ${selectedColor === item.id ? "selected-border" : ""}
            ${isOutOfStock(item) ? "disabled" : ""}
            ${item.id === "none" ? "grid-item-none" : ""}
          `.trim()}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "4px",
            height: "100%",
            color: "white",
            backgroundImage: `url("${item.bg}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: item?.id === "none" ? "60% auto" : "cover",
          }}
        ></div>
      ))}
    </div>
  );
};

export default Component4;
